import React, { Component } from 'react';
import snsTwitterImg from '../../static/images/twitter.svg';
import snsFacebookImg from '../../static/images/facebook.svg';
import snsGooglePlusImg from '../../static/images/google-plus.svg';
import snsHatebuImg from '../../static/images/hatebu.svg';
import {
  ShareButtons
} from 'react-share-with-hatena';

export default class Social extends Component {
  render () {
    return (
      <div className='socials'>
        <ShareButtons.TwitterShareButton url={this.props.url} title={this.props.text}>
          <img src={snsTwitterImg} alt='twitter' />
        </ShareButtons.TwitterShareButton>
        <ShareButtons.FacebookShareButton url={this.props.url}>
          <img src={snsFacebookImg} alt='facebook' />
        </ShareButtons.FacebookShareButton>
        <ShareButtons.GooglePlusShareButton url={this.props.url}>
          <img src={snsGooglePlusImg} alt='google+' />
        </ShareButtons.GooglePlusShareButton>
        <ShareButtons.HatenaShareButton url={this.props.url}>
          <img src={snsHatebuImg} alt='hatebu' />
        </ShareButtons.HatenaShareButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/social.js